import { memo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ShipmentStopsTileFilter } from '@api/order-reporting/types/ShipmentStopsParams';
import { selectValidParams } from '@pages/reporting-pages/shipment-stops/store/selectors';
import { setTileId } from '@pages/reporting-pages/shipment-stops/store/slice';
import { useLazyShipmentStopsTilesQuery } from '@api/order-reporting/api';
import SimpleStatisticCard from 'components/statistic-card/SimpleStatisticCard';
import LoadingElement from 'components/base-elements/loading/LoadingElement';



export const StatisticArea = () => {

	const validParams = useSelector(selectValidParams);
	const validParamsRenderKey = validParams ? `${validParams.customerId}-${validParams.day}` : null;
	const dispatch = useDispatch();
	const dispatchTileId = (tileId: string) => dispatch(setTileId(tileId));

	const [ runQuery, { data, isLoading, isFetching, isError } ] = useLazyShipmentStopsTilesQuery();

	useEffect(() => {
		if (validParams) {
			runQuery({ ...validParams }, true);
		}
	}, [ validParamsRenderKey ]);


	if (isLoading || isFetching) return (
		<div className='statistic-area'>
			<LoadingElement size={2}/>
		</div>
	);
	
	if (!data || isError) return (
		<div className='statistic-area'>
		</div>
	);

	return (
		<div className='statistic-area'>

			<SimpleStatisticCard
				data={{
					id: 'shipment-stop-report-statistic-card-all-stops-count',
					label: 'Zastávek celkem',
					value: data.total,
				}}
				onClick={() => dispatchTileId(String(ShipmentStopsTileFilter.total))} />

			<SimpleStatisticCard
				data={{
					id: 'shipment-stop-report-statistic-card-delivered-count',
					label: 'Doručeno',
					value: data.delivered,
				}}
				onClick={() => dispatchTileId(String(ShipmentStopsTileFilter.delivered))} />

			<SimpleStatisticCard
				data={{
					id: 'shipment-stop-report-statistic-card-on-way-count',
					label: 'Na cestě',
					value: data.onWay,
				}}
				onClick={() => dispatchTileId(String(ShipmentStopsTileFilter.onWay))} />

			<SimpleStatisticCard
				data={{
					id: 'shipment-stop-report-statistic-card-on-dc-count',
					label: 'Na DC',
					value: data.atDc,
				}}
				onClick={() => dispatchTileId(String(ShipmentStopsTileFilter.atDc))} />
		</div>
	)
}

export default memo(StatisticArea);